// vueform.config.(js|ts)

import en from '@vueform/vueform/locales/en'
import tailwind from '@vueform/vueform/dist/tailwind'
import { defineConfig } from '@vueform/vueform'

export default defineConfig({
  theme: tailwind,
  locales: { en },
  locale: 'en',
  floatPlaceholders: false,
  addClasses: {
    MultiselectElement: {
      container: 'form-group space-y-2',
      label: 'form-label text-gray-700 dark:text-gray-400',
      select: {
        container:
          'form-control bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100 border-gray-300 dark:border-gray-600 rounded-md shadow-sm',
        dropdown:
          'vfc-dropdown bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100 border-gray-300 dark:border-gray-600',
        options:
          'vfc-dropdown-items bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100 hover:bg-gray-200 dark:hover:bg-gray-700',
        search:
          'pl-2 bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100',
        placeholder: 'pl-2 text-gray-500 dark:text-gray-400',
        singleLabel: 'pl-2 text-gray-900 dark:text-gray-100',
      },
    },
    SelectElement: {
      container: 'form-group space-y-2',
      label: 'form-label text-gray-700 dark:text-gray-400',
      select: {
        container:
          'form-control bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100 border-gray-300 dark:border-gray-600 rounded-md shadow-sm',
        dropdown:
          'vfc-dropdown bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100 border-gray-300 dark:border-gray-600',
        options:
          'vfc-dropdown-items bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100 hover:bg-gray-200 dark:hover:bg-gray-700',
        search:
          'pl-2 bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100',
        placeholder: 'pl-2 text-gray-500 dark:text-gray-400',
        singleLabel: 'pl-2 text-gray-900 dark:text-gray-100',
      },
    },
    TagsElement: {
      container: 'form-group space-y-2',
      label: 'form-label text-gray-700 dark:text-gray-400',
      select: {
        container:
          'pl-1 bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100 border-gray-300 dark:border-gray-600 rounded-md shadow-sm',
        dropdown:
          'vfc-dropdown bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100 border-gray-300 dark:border-gray-600',
        options:
          'vfc-dropdown-items bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100 hover:bg-gray-200 dark:hover:bg-gray-700',
        search:
          'pl-2 bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100',
        placeholder: 'pl-2 text-gray-500 dark:text-gray-400',
        singleLabel: 'pl-2 text-gray-900 dark:text-gray-100',
        tags: 'pl-0 text-gray-900 dark:text-gray-100',
      },
    },
    TextElement: {
      input:
        'form-control bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100 border-gray-300 dark:border-gray-600 rounded-md shadow-sm',
      container: 'vfc-text-label space-y-2',
    },
    CheckboxElement: {
      input:
        'no-selectable mb-0 size-8 form-checkbox bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100 border-gray-300 dark:border-gray-600 rounded',
      container: 'vfc-text-label space-y-2',
    },
    RadiogroupElement: {
      input:
        'no-selectable mb-0 size-8 form-radio bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100 border-gray-300 dark:border-gray-600',
      wrapper: 'flex',
      container: 'vfc-text-label space-y-2',
    },
  },
})
